import { gql } from '@apollo/client';
import useGQLQuery from 'src/lib/graphql/hooks/useGQLQuery';
import { EP_ANCESTORS_DETAILS_FIELDS } from '../common/fragments/ancestorsDetails';
export const EP_QUESTION_DATA_FIELDS = gql `
  fragment EPQuestionDataFields on EPQuestionData {
    questionHTML
    marks
    topics
    sequence
    label
    isSubQuestion
  }
`;
export const EP_QUESTION_FIELDS = gql `
  fragment EPQuestionFields on EPQuestion {
    id
    type
    data {
      ...EPQuestionDataFields
    }
    config {
      WRITTEN_QUESTION {
        hasExaminersFeedback
      }
    }
    attributes {
      answered
    }
    userData {
      read
      bookmarked
    }
    ancestorsDetails @include(if: $withAncestorsDetails) {
      ...EPAncestorsDetailsFields
    }
    examinersFeedback @include(if: $withEF) {
      id
      data {
        feedback
      }
    }
    answer {
      id
      data {
        latestAnswer {
          ctime
          answer
        }
        answerHistoryCount
      }
      config {
        WRITTEN_ANSWER {
          contribution {
            enableHistory
            enableEdit
          }
        }
      }
    }
    questionPaper {
      id
      data {
        label
        dateNL
      }
    }
    duplicates {
      id
      questionPaper {
        id
        data {
          label
          dateNL
        }
      }
      examinersFeedback @include(if: $withEF) {
        id
        data {
          feedback
        }
      }
    }
  }

  ${EP_QUESTION_DATA_FIELDS}
  ${EP_ANCESTORS_DETAILS_FIELDS}
`;
export const EP_QUESTION_DETAILS_QUERY = gql `
  query EP_QuestionDetails(
    $questionID: ID!
    $withAncestorsDetails: Boolean = true
    $withEF: Boolean = true
  ) {
    ep_questionDetails(questionID: $questionID) {
      ...EPQuestionFields
    }
  }

  ${EP_QUESTION_FIELDS}
`;
export function useQuestionDetailsQuery(options) {
    return useGQLQuery(EP_QUESTION_DETAILS_QUERY, options);
}
